import {
  EmptyState,
  SupportTicketButton,
} from '../../../common/components/EmptyState/EmptyState'
import { useStyles } from '../ChannelOffers.styles'
import Disable from '../../../common/images/Disable.png'
import { FeatureListForBlockPage } from './FeatureListForBlockPage'
import clsx from 'clsx'
import { isvEmptyStatefeaturesList } from './constants'

export { isvEmptyStatefeaturesList } from './constants'

export const IsvChannelOffersEmptyState = () => {
  const { classes } = useStyles()
  return (
    <div
      className={classes.emptyStateContainer}
      data-testid="empty-channel-offer-for-isv"
    >
      <EmptyState
        imgSrc={Disable}
        header="Invite your Resellers to Labra"
        content={
          <div
            className={clsx(
              classes.emptyStateContent,
              classes.emptyStateContentLeftSpace
            )}
          >
            <FeatureListForBlockPage features={isvEmptyStatefeaturesList} />
          </div>
        }
        action={<SupportTicketButton />}
      />
    </div>
  )
}
